import { HealthStatus } from "@/installation/garyStatus";
import type { CopilotStatus } from "./StatusDot";

export function healthStatusToCopilot(status: HealthStatus | string): CopilotStatus {
  switch (status) {
    case HealthStatus.red:
      return "critical";
    case HealthStatus.yellow:
      return "warning";
    case HealthStatus.green:
      return "healthy";
    case HealthStatus.black:
    default:
      return "neutral";
  }
}
